module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"meta":{"title":"Apie mus","description":"Nogrid - atsinaujinančios energetikos rangos įmonė, kuri rūpinasi visais saulės energijos įdiegimo etapais nuo projektavimo iki priežiūros. Mumis pasitiki klientai iš gamybos, logistikos, mažmeninės prekybos ir kitų sektorių."},"side":"Inovatyvių saulės energijos sprendimų namams ekspertai","title":"Saulės elektrinės|ateities namams"}}')
  delete Component.options._Ctor
}
